import webConfig from './base';

const { domain, contextRoot } = webConfig;

/* Create  setLocale */
/* Read    getLocale */
/* Update  updateLocale */
/* Delete  deleteLocale */
export default {
	getContextRoot: contextRoot,
	getLocale: `${contextRoot}data/`,
	getLocaleEN: `${contextRoot}data/en.json`,
	domain: `${domain}`,
	getPublicationMap: `${domain}/pub/location/list/1.0?limit=-1&offset=0`,
	getPublicationMapV2: `${domain}/pub/location/list/1.1?limit=-1&offset=0`,
	// filter publication of (publication || author || location) with keyword
	getPublicationInfo: `${domain}/search/map/keyword/1.0?limit=-1&offset=0&keyword={keyword}`,
	getPublicationInfoByYear: `${domain}/search/map/year/1.0?limit=-1&offset=0&year={year}`,
	getPublicationCardInfo: `${domain}/pub/cardinfo/1.0?limit=-1&offset=0&lang=en&pubId={pubId}`,
	getPublicationInfoOfLocInfo: `${domain}/location/cardinfo/1.0?limit=-1&offset=0&locId={locId}`,
	getPublicationInfoOfLocInfoV2: `${domain}/location/cardinfo/1.1?limit=-1&offset=0&locId={locId}`,
	getSNAData: `${domain}/pub/relation/1.1?limit=-1&offset=0`,
};
